export default {
  title: '¿Estás seguro?',
  description: 'Los siguientes grupos de modificadores (incluidos sus modificadores) se eliminarán:',
  buttons: {
    yes: 'Sí',
    no: 'No',
  },
  toasts: {
    modifier_group_got_deleted: 'Grupos de modificadores eliminados',
    failed_to_delete_modifier_group: 'Error al eliminar el grupo de modificadores',
  },
};
